import { useContext } from 'react';

import { ListingPageComponentRefsContext } from '@/providers/ListingPageComponentRefsProvider';

export const useListingPageComponentRefs = () => {
  const context = useContext(ListingPageComponentRefsContext);

  if (context === undefined) {
    throw new Error('useListingPageComponentRefs must be used within a ListingPageComponentRefsProvider');
  }

  return context;
};
